import {
  BeaconEventMarketingPageElementLocation,
  BeaconEventMarketingPageElementType,
  ExtendedDrupal,
  ExtendedDrupalData,
  ExtendedDrupalNode,
  ExtendedPageTemplateProps,
  I18nDataEdges,
  isDefined,
  LinkInterface,
  MarketoFormData,
  MarketoFormInterface,
  PageContext,
  PageMarketoExtraData,
  PageMetatag,
  PageTemplateProps
} from '@lucid/utils';
import {
  Drupal_ParagraphMarketoForm,
  Maybe,
  Scalars
} from 'generated/drupal-graphql';

export interface MarketoFormField {
  targetId?: Maybe<Scalars['Int']>;
  entity?: Maybe<Drupal_ParagraphMarketoForm>;
  targetRevisionId?: Maybe<Scalars['Int']>;
}

export enum Template {
  Assignment = 'assignment',
  Homepage = 'case_study_hub',
  Consideration = 'homepage',
  IntegrationsPage = 'integrations_page',
  Nineteen = 'nineteen'
}

export {
  BeaconEventMarketingPageElementLocation,
  BeaconEventMarketingPageElementType,
  ExtendedDrupal,
  ExtendedDrupalData,
  ExtendedDrupalNode,
  ExtendedPageTemplateProps,
  I18nDataEdges,
  isDefined,
  LinkInterface,
  MarketoFormData,
  MarketoFormInterface,
  PageContext,
  PageMarketoExtraData,
  PageMetatag,
  PageTemplateProps
};
